import { useRef, useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, RotateCcw } from "lucide-react";

const MP4 = "/veylo-ai-intro.mp4";

export const IntroVideo = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [failed, setFailed] = useState(false);
  const [key, setKey] = useState(0);

  const retry = () => {
    setFailed(false);
    setKey((k) => k + 1);
  };

  return (
    <Card className="overflow-hidden">
      <div className="p-4 border-b">
        <h2 className="font-semibold">Getting started with Veylo AI</h2>
        <p className="text-sm text-muted-foreground">From your first data upload to managing your plan.</p>
      </div>
      <div className="aspect-video bg-muted/40">
        {failed ? (
          <div className="flex h-full flex-col items-center justify-center gap-3 p-4 text-center">
            <p className="text-sm text-muted-foreground">The video couldn't play on this device.</p>
            <Button size="sm" variant="outline" onClick={retry} className="gap-2">
              <RotateCcw className="h-4 w-4" /> Try again
            </Button>
          </div>
        ) : (
          <video
            key={key}
            ref={videoRef}
            controls
            preload="metadata"
            playsInline
            aria-label="Veylo AI introduction and payments walkthrough"
            className="h-full w-full"
            onError={() => setFailed(true)}
          >
            <source src={MP4} type="video/mp4" onError={() => setFailed(true)} />
          </video>
        )}
      </div>
      <div className="flex justify-end p-3 border-t">
        <Button asChild size="sm" variant="outline" className="gap-2">
          <a href={MP4} download="veylo-ai-intro.mp4">
            <Download className="h-4 w-4" /> Download video
          </a>
        </Button>
      </div>
    </Card>
  );
};
